const SANITIZED_NUMBER_SUFFIX = /(qty|quantity|amount|weight)$/i;
const SANITIZED_NUMBER = /(qty|quantity|amount|weight)/i;
const NOS_SUFFIX = /nos$/i;

export function isSanitizedNumberColumn(colDef) {
  const field = String(colDef?.field || '').replace(/[\s_-]/g, '');
  const header = String(colDef?.headerName || '').replace(/[\s_-]/g, '');
  const types = Array.isArray(colDef?.type) ? colDef.type : [colDef?.type];
  const isNumericColumn = types.some(type => String(type).toLowerCase() === 'numericcolumn');
  return (
    SANITIZED_NUMBER_SUFFIX.test(field)
    || SANITIZED_NUMBER_SUFFIX.test(header)
    || (
      isNumericColumn
      && (
        SANITIZED_NUMBER.test(field)
        || SANITIZED_NUMBER.test(header)
        || NOS_SUFFIX.test(field)
        || NOS_SUFFIX.test(header)
      )
    )
  );
}

export function parseAgGridNumber(value, oldValue, precision = 3) {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const number = Number(String(value).replace(/,/g, '').trim());
  if (!Number.isFinite(number)) return oldValue ?? null;
  const decimals = Number.isInteger(precision) && precision >= 0 ? precision : 3;
  return number.toFixed(decimals);
}
